import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import ResumeItem from '@/common/components/ResumeItem'
import { cn } from '@/common/utils/cn'
import { formatDateTime } from '@/common/utils/formatters'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import {
  MaintenanceForwardingDirectiveEntryStatus,
  MaintenanceForwardingStatus,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

const MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry = () => {
  const { forwarding, forwardingUpdatedAt } =
    useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>()

  const navigate = useNavigate()

  const isAwaitingCheckin = useMemo(() => {
    return forwarding?.status === MaintenanceForwardingStatus.OnGoingCheckin
  }, [forwardingUpdatedAt])

  const isAwaitingEndOfMaintenance = useMemo(() => {
    return (
      !isAwaitingCheckin &&
      forwarding?.directive_entry?.status &&
      [
        MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
        MaintenanceForwardingDirectiveEntryStatus.InProgress,
      ].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt])

  const isAwaitingClientReview = useMemo(() => {
    return (
      !isAwaitingEndOfMaintenance &&
      forwarding?.directive_entry?.status &&
      [MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt, isAwaitingEndOfMaintenance])

  const isCompleted = useMemo(() => {
    return (
      !isAwaitingClientReview &&
      forwarding?.directive_entry?.status &&
      [MaintenanceForwardingDirectiveEntryStatus.Completed].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt, isAwaitingClientReview])

  return (
    <Box className={cn('p-4 flex flex-col gap-4', isAwaitingClientReview && 'bg-yellow-op-2')}>
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">Execução da manutenção</p>

          {isAwaitingCheckin && (
            <div>
              <p className="text-warning text-xs">Aguardando Check-in</p>
            </div>
          )}

          {isAwaitingEndOfMaintenance && (
            <div>
              <p className="text-warning text-xs">Aguardando fim da manutenção</p>
            </div>
          )}

          {isCompleted && (
            <div>
              <p className="text-valid text-xs">Concluído</p>
            </div>
          )}
        </div>

        {isAwaitingClientReview && (
          <div>
            <Button
              onClick={() => navigate(`${forwarding.id}/execution/${forwarding?.directive_entry?.id}`)}
              operationKlassToCheckPermission="Client::Maintenance::Directive::ExecutionEntries::Advance"
            >
              Vistoria da manutenção
            </Button>
          </div>
        )}
      </div>

      {(forwarding?.checkin_entry?.completed_at || forwarding?.checkin_entry?.responsible) && (
        <div className="flex gap-3">
          {forwarding?.checkin_entry?.completed_at && (
            <ResumeItem
              label="Check-in realizado"
              value={formatDateTime(new Date(forwarding?.checkin_entry?.completed_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding?.checkin_entry?.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding?.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      )}
    </Box>
  )
}

export default MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry
